import { call, put, select, takeLatest } from "typed-redux-saga";
import type { PayloadAction } from "@reduxjs/toolkit";
import { ApiClientAxios, apiFactoryConfig } from "@repo/api";
import {
	fetchAllowedChanges,
	fetchAllowedChangesFailed,
	setAllowedChanges,
	selectIsLoaded,
} from "../slices/allowedChangesSlice";

const getAllowedChanges = async (): Promise<ApiClientAxios.GetAllowedChangesResponse> => {
	const api = ApiClientAxios.ContractsApiFactory(...apiFactoryConfig);
	const response = await api.getAllowedChangesGet();

	return response.data;
};

function* fetchAllowedChangesSaga(action: PayloadAction<{ force?: boolean } | undefined>) {
	const alreadyLoaded = yield* select(selectIsLoaded);
	if (alreadyLoaded && action.payload?.force !== true) {
		return;
	}

	try {
		const response = yield* call(getAllowedChanges);

		yield* put(setAllowedChanges(response));
	} catch (e) {
		const message = e instanceof Error ? e.message : "Failed to load allowed changes";
		yield* put(fetchAllowedChangesFailed(message));
	}
}

export function* allowedChangesSaga() {
	yield* takeLatest(fetchAllowedChanges.type, fetchAllowedChangesSaga);
}
